var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-lazy-image",class:{ '_loading': _vm.loading, '_loaded': _vm.loaded }},[_c('img',{ref:"img",class:_vm.imageClass,attrs:{"src":_vm.mutableSrc,"width":_vm.width,"height":_vm.height,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }